export default {
  debug: false,
};
